export enum StorageProperties {
  categoryExpansionState = "category-expansion-state:"
}
